module.exports = __webpack_public_path__ + "static/media/Frillish_gaussian2.9b7bc582.png";